<div class="content">
  <rd-shared-icon
    class="icon-not-found"
    [iconSymbol]="'icon-not-found'"
    [iconTheme]="'error'"></rd-shared-icon>
  <h1 class="login-header">{{ 'wl.westpac.auth.login_header' | translate }}</h1>
  <p class="login-description">
    {{ 'wl.westpac.auth.login_description' | translate }}
  </p>

  <rd-shared-button
    class="login-button"
    [buttonClass]="'login-button'"
    [buttonContent]="loginButtonContent"
    [buttonTheme]="'primary'"
    (clickFn)="redirectToLoginUrl()">
    <ng-template #loginButtonContent>
      <span>{{ 'wl.westpac.auth.login_button' | translate }}</span>
    </ng-template>
  </rd-shared-button>
</div>
